import { createContext, ReactNode, useContext } from 'react';
import { MessageActions, MessageType } from 'types/chat.types';

interface MessageContextValue {
  message: MessageType;
  messageActions: MessageActions;
}

interface MessageProviderProps {
  value: MessageContextValue;
  children: ReactNode;
}

const MessageContext = createContext<MessageContextValue | undefined>(
  undefined
);

export const MessageProvider = ({ children, value }: MessageProviderProps) => (
  <MessageContext.Provider value={(value as unknown) as MessageContextValue}>
    {children}
  </MessageContext.Provider>
);

export const useMessageContext = () => {
  const contextValue = useContext(MessageContext);
  return (contextValue as unknown) as MessageContextValue;
};
